import React from 'react';
import { PdfComponentBorderProperties, PdfTableComponent } from '../../PdfComponent';
import PdfTemplateComponentDefault from '../properties/PdfTemplateComponentDefault';
import PdfTemplateComponentFont from '../properties/PdfTemplateComponentFont';
import PdfTemplateTableColumns from './table/PdfTemplateTableColumns';
import PdfTemplateTableRowsSettings from './table/PdfTemplateTableRowsSettings';
import { usePdfTemplateContext } from '../../PdfTemplateEditorContext';
import { Checkbox } from '../../../../components/Checkbox';
import PdfTemplateComponentBorderColor from '../properties/border/PdfTemplateComponentBorderColor';
import PdfTemplateComponentBorderWidth from '../properties/border/PdfTemplateComponentBorderWidth';

export default function PdfTemplateTableComponentProperties({ component }: { component: PdfTableComponent }) {
  const { updateComponent } = usePdfTemplateContext();

  const updateBorder = (border: Partial<PdfComponentBorderProperties>) => {
    updateComponent(component.id, { border: { ...component.border, ...border } });
  };

  return (
    <div className='grid gap-2'>
      <PdfTemplateComponentDefault component={component} />

      <p className='section-title mt-2'>Style</p>
      <p className='text-lg text-title'>Font</p>
      <PdfTemplateComponentFont component={component} />
      <PdfTemplateComponentFont
        component={component}
        controller={{
          font: component.headerFont,
          onChange: font => updateComponent(component.id, { headerFont: font }),
          checkboxLabel: 'Use same style for header',
        }}
      />

      <p className='text-lg text-title'>Border</p>
      <PdfTemplateComponentBorderColor component={component} updateBorder={updateBorder} />
      <PdfTemplateComponentBorderWidth component={component} updateBorder={updateBorder} />
      <div className='grid grid-cols-2 gap-2'>
        <Checkbox
          onChange={checked => updateComponent(component.id, { borderCellsVertical: checked })}
          label={'Vertical cell borders'}
          value={component.borderCellsVertical}
        />
        <Checkbox
          onChange={checked => updateComponent(component.id, { borderCellsHorizontal: checked })}
          label={'Horizontal cell borders'}
          value={component.borderCellsHorizontal}
        />
      </div>

      <p className='text-lg text-title'>Rows</p>
      <PdfTemplateTableRowsSettings component={component} />
      <PdfTemplateTableColumns component={component} />
    </div>
  );
}
